// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"88":"player","118":"document-detail","264":"target","594":"about","884":"admin","966":"login"}[chunkId] || chunkId) + "." + {"88":"37423680","118":"9d4dba44","180":"f0f53d09","264":"f64093c7","594":"9cd9e2a2","884":"d3e0177a","966":"4f71fde5"}[chunkId] + ".js";
};